module.exports = "<sq-building />\n";